import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';

export interface Avatar {
    DefaultAvatarId: number;
    FilePath: string;
}

interface APIResponse {
    success: boolean;
    errCode: string;
    permissions?: string[];
    profile?: {
        institution: string;
    };
    defaultAvatars?: Avatar[];
    email?: string;
}

const GetInitData = async () => {
    const {
        setLoading,
        setFormError,
        setPermissions,
        setProfile,
        setDefaultAvatars,
        setEmail,
    } = useStore.getState();

    setLoading(true);
    sendRequest(
        {
            endpoint: '/user/get-init-data',
        },
        (data: APIResponse) => {
            let {
                success,
                errCode,
                permissions,
                profile,
                defaultAvatars,
                email,
            } = data;

            if (success) {
                setPermissions(permissions);
                setProfile(profile);
                setDefaultAvatars(defaultAvatars);
                setEmail(email);
                setLoading(false);
            } else if (!success && errCode) {
                setLoading(false);
                setFormError(errCode);
            }
        }
    );
};

export default GetInitData;
